/*
 * File: /src/services/campaignServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 27th June 2019 4:08:11 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from 'src/shared/axiosWrapper';
import { AD_BASE_CAMPAIGNS_PATH } from '../constants';

export default {
  /**
   * Fetch All Campaigns
   */
  fetchCampaigns(archive = false, brandId) {
    let params = {};
    if (archive) {
      params['archived'] = true;
    }
    const filters = [];
    if (brandId) {
      filters.push('brand_id:eq:' + brandId)
      params['filter'] = filters;
    }
    return authedAxios.get(AD_BASE_CAMPAIGNS_PATH, {params: params});
  },

  /**
   * Fetch Campaign
   * @param {number} id
   * @returns
   */
  fetchCampaign(id) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}${id}`);
  },

  /**
   * Fetch Campaign Reports
   * @param {number} id
   */
  fetchCampaignsReports(id) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}email-report/${id}`);
  },

  getEmailStats(id, statType) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}email-report/${id}/${statType}`);
  },
  getEmailErrors(id) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}email-errors/${id}`);
  },
  /**
   * Fetch Campaign Sms Reports
   * @param {number} id
   */
  fetchCampaignsSmsReports(id) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}sms-report/${id}`);
  },

  fetchCampaignsPostcardReports(id) {
    return authedAxios.get(`${AD_BASE_CAMPAIGNS_PATH}postcard-report/${id}`);
  },

  /**
   * Send Campaign
   * @param {number} campaignId
   */
  changeCampaignStatus(campaignId, payload) {
    return authedAxios.post(`${AD_BASE_CAMPAIGNS_PATH}status/${campaignId}`, payload);
  },

  /**
   * Initialize Campaign
   * @param {CampaignInputModel} campaignObject
   * @returns
   */
  initCampaign(campaignObject) {
    return authedAxios.post(AD_BASE_CAMPAIGNS_PATH, campaignObject);
  },

  /**
   * Patch Campaign
   * @param {number} id
   * @param {CampaignInputModel} campaignObject
   * @returns
   */
  patchCampaign(id, campaignObject) {
    return authedAxios.patch(AD_BASE_CAMPAIGNS_PATH + id, campaignObject);
  },

  /**
   * Re-Send Campaign to Un Opens
   *
   * @param {*} campaignId
   * @returns
   */
  sendToUnOpens(campaignId, schedule) {
    return authedAxios.post(
      AD_BASE_CAMPAIGNS_PATH + 'send-un-opens/' + +campaignId + '/',
      {
        scheduled: schedule,
      }
    );
  },

  /**
   * Delete Campaign
   * @param {number} id
   */
  deleteCampaign(id) {
    return authedAxios.delete(AD_BASE_CAMPAIGNS_PATH + id);
  },
};
